import styled from 'styled-components';
import Colours from '/shared/styled/Colours';

interface Props {
  $isInvertedFooter?: boolean;
}

export default styled.div<Props>`
  position: relative;
  display: flex;
  flex: 1 1 0;
  flex-direction: column;
  justify-content: space-between;
  min-width: 0;
  min-height: 15.5rem;
  padding: 1.5rem;
  padding-top: 1.75rem;
  background-color: ${Colours.white};
  border: 1px solid ${Colours.greyLight6};
  border-radius: 0 0 0.25rem 0.25rem;
  box-shadow: 0 0 2rem 0 ${Colours.shadowLight1};

  &::before {
    content: '';
    position: absolute;
    top: -1px;
    left: -1px;
    width: calc(100% + 2px);
    height: 3px;
    background-color: ${Colours.green};
  }

  img {
    max-height: 3rem;
    margin-bottom: 1.25rem;
  }

  a {
    margin-top: 2rem;
    align-self: flex-start;
    padding: 1rem 1rem;
    width: 100%;
  }
`;
